import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { MyCarsButtons } from 'wsm-mycars-buttons';
import { MyCarsCtas } from 'wsm-mycars-ctas';
import { useFlags, usePrefs, useLabels } from 'wsm-common-data';
import { selectIsTabbedLayout } from '../../../features/layoutSlice';

const MyCars = ({ uuid }) => {
	const flags = useFlags();
	const { mycarsSaveLabel, mycarsSavedLabel } = usePrefs();
	const labels = useLabels();
	const isTabbedLayout = useSelector((state) => selectIsTabbedLayout(state));
	const modernMyCarsLabels = [
		{
			id: 'trackPrice',
			default: labels.get('TRACK_PRICE')
		},
		{
			id: 'save',
			default: labels.get(mycarsSaveLabel)
		}
	];
	const enableModernMyCars = flags['enable-modern-mycars'];
	const classNames = {
		mobileClasses: {
			container: 'w-100 justify-content-around'
		},
		commonClasses: {
			gap: 'ml-6'
		}
	};
	return (
		<>
			{enableModernMyCars ? (
				<MyCarsCtas
					uuid={uuid}
					isInLine={!isTabbedLayout}
					classNames={classNames}
					labels={modernMyCarsLabels}
				/>
			) : (
				<MyCarsButtons
					key="MyCarsButtonComponent"
					uuid={uuid}
					isLink
					{...{
						mycarsSaveLabel,
						mycarsSavedLabel
					}}
				/>
			)}
		</>
	);
};

MyCars.propTypes = {
	uuid: PropTypes.string.isRequired
};

export default MyCars;
